import MyPulse365 from './MyPulse365.vue';

export default {
  path: '/my/pulse365',
  name: 'My Pulse 360',
  component: MyPulse365,
  meta: {
    auth: true,
    label: 'MyPulse365',
  },
};
